
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/native-select",
      function () {
        return require("private-next-pages/material-ui/api/native-select.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/native-select"])
      });
    }
  